<template>
  <div class="content">
    <div class="bodycontent">
      <el-form :model="formData" :rules="rules" ref="formData" label-width="180px">
        <el-form-item label="商户名称" prop="merch_name">
          <el-input v-model="formData.merch_name" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="商户logo">
          <el-upload
            ref="upload"
            class="avatar-uploader"
            action="https://www.58zltc.com/api/Upload/uploads/"
            :show-file-list="false"
            accept="image/*"
            :on-success="handleAvatarSuccess"
            :data="imgdata"
            :on-change="changefile"
            :auto-upload="false"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="商户性质">
          <el-radio-group v-model="formData.merch_pro">
            <el-radio :label="1">个人</el-radio>
            <el-radio :label="0">企业</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="入驻板块">
          <el-radio-group v-model="formData.settle_type">
            <el-radio :label="1">商城</el-radio>
            <el-radio :label="0">团购</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="有无店铺">
          <el-radio-group v-model="formData.is_shop">
            <el-radio :label="1">无实体店</el-radio>
            <el-radio :label="0">有实体店</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="入住行业">
          <span style="margin-right:20px;" v-if="industryName">{{industryName}}</span>
          <el-button @click="showIndustry = true">{{buttonText}}</el-button>
        </el-form-item>
        <el-form-item label="主营项目">
          <el-input v-model="formData.run_type" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="商户分类">
          <el-input v-model="formData.cate_id" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="formData.contact_name" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="formData.contact_mobile" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="商户简介">
          <el-input
            type="textarea"
            v-model="formData.brief"
            placeholder="100字以内"
            class="input_box"
            rows="3"
          ></el-input>
        </el-form-item>
        <el-form-item label="商户地址">
          <el-input v-model="formData.address" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="商户电话">
          <el-input v-model="formData.num" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="商户位置">
          经度：
          <el-input readonly class="half_input" v-model="mapPoint.lng"></el-input>纬度：
          <el-input readonly class="half_input" v-model="mapPoint.lat"></el-input>
          <el-button @click="mapButton()">选择坐标</el-button>
        </el-form-item>
        <el-form-item label="是否推荐">
          <el-radio-group v-model="formData.is_rec">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="label">
          <p>
            <span></span>账号信息
          </p>
        </div>
        <el-form-item label="主账户名">
          <el-input v-model="formData.user" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="主账户密码">
          <el-input v-model="formData.password" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="子账户数量">
          <el-input v-model="formData.child_num" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="商品数量">
          <el-input v-model="formData.goods_num" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="服务到期时间">
          <el-date-picker
            v-model="formData.expire_time"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            class="input_box"
          ></el-date-picker>
        </el-form-item>
        <div class="label">
          <p>
            <span></span>商户权限组
          </p>
        </div>
        <el-form-item label="商户组">
          <el-input v-model="formData.group_id" class="input_box"></el-input>
        </el-form-item>
        <div class="label">
          <p>
            <span></span>商户备注
          </p>
        </div>
        <el-form-item label="商户备注">
          <el-input type="textarea" v-model="formData.remark" class="input_box" rows="4"></el-input>
        </el-form-item>
        <div class="label">
          <p>
            <span></span>入驻状态
          </p>
        </div>
        <el-form-item label="状态">
          <el-radio-group v-model="formData.apply_status">
            <el-radio :label="0">待入驻</el-radio>
            <el-radio :label="2">允许入驻</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="label">
          <p>
            <span></span>商户状态
          </p>
        </div>
        <el-form-item label="状态">
          <el-radio-group v-model="formData.status">
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="label">
          <p>
            <span></span>商户结算
          </p>
        </div>
        <el-form-item label="抽成比例">
          <el-input v-model="formData.percent" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="收款人">
          <el-input v-model="formData.payee" class="input_box"></el-input>
        </el-form-item>
        <div class="label">
          <p class="longtext">
            <span></span>多商户积分商城积分订单提现
          </p>
        </div>
        <el-form-item label="积分商城提现">
          <el-radio-group v-model="formData.is_integral">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="积分兑换">
          <el-radio-group v-model="formData.integral_exchange">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="兑换比例">
          <el-input v-model="formData.exchange" class="input_box">
            <template slot="append">积分：1元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="收款人">与商户结算收款人为同一人</el-form-item>
      </el-form>
      <div class="bottom_btn">
        <el-button type="primary" @click="submit">提交</el-button>
        <el-button type="info" class="ml30" @click="goback">返回列表</el-button>
      </div>
      <!-- 地图选择 -->
      <el-dialog :visible.sync="showmap" @close="closeMap">
        <div class="map_search">
          <el-input v-model="mapKeyword">
            <template slot="append">
              <el-button @click="searchMap">搜索</el-button>
            </template>
          </el-input>
        </div>
        <Map @getPoint="getpoint" ref="Bmap"></Map>
        <div class="map_button">
          <span>经度：{{ mapPoint.lng }}</span>
          <span>纬度：{{ mapPoint.lat }}</span>
          <div>
            <el-button @click="closeMap()">确定</el-button>
          </div>
        </div>
      </el-dialog>
      <!-- 入驻行业选择 -->
      <el-dialog :visible.sync="showIndustry" @close="closeIndustry" width="400px" title="选择行业">
        <div class="industry_list">
          <div class="industry_item" v-if="showLastPage" @click="lastPage()">返回上一级</div>
          <div class="industry_item" v-for="(item,index) in showlist" :key="item.id" @click="selectItem(index)">
            <div class="name">{{item.name}}</div>
            <div class="arrow" v-if="item.children.length">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Map from "@/components/map/bmap";
import { AddMerchant, EditMerchant, GetIndustry } from "@/api/merchant";
export default {
  components: {
    Map
  },
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  mounted() {
    this.$store.commit("SET_STATE", "2");
    this.init();
    // this.test();
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("SET_STATE", "1");
    next();
  },
  data() {
    return {
      formData: {},
      industryList:[], //行业列表 所有
      showlist:[], //展示的行业列表
      showLastPage: false, //显示返回上一级
      industryName:"", //已选行业
      buttonText:"选择", //入驻行业按钮文字
      showIndustry: false, //选择行业弹窗
      showLastPage: false, //是否有上一页
      history:[], //选择行业历史栈
      imageUrl: "", //上传的图片地址
      imgdata: {}, //上传图片附加信息
      image_id: "", //上传后服务器路径
      if_add: true,
      showmap: false, //地图弹窗
      mapKeyword: "", //地图搜索关键字
      mapPoint: {},
      rules: {
        merch_name: [
          { required: true, message: "请输入分类名称", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    init() {
      console.log(this.$route.query);
      this.formData = this.$route.query.editData || {
        sort: "",
        name: "",
        merch_pro: 1,
        settle_type: 1,
        apply_status: 2,
        status: 1,
        is_shop: 0,
        is_rec: 0,
        is_integral: 1,
        integral_exchange: 1
      };
      if (this.formData.id) {
        this.if_add = false;
      }
      //获取行业列表
      var data = {};
      data.token = this.token;
      data.app_id = this.app_id;
      GetIndustry(data).then(res => {
        console.log(res);
        if (res.code == "200") {
          this.industryList = res.data;
          this.showlist = this.industryList;
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    goback() {
      this.$router.go(-1);
    },
    submit() {
      if (this.imageUrl != "") {
        this.$refs.upload.submit();
      } else {
        this.save();
      }
    },
    //地图搜索
    searchMap(){
      this.$refs.Bmap.search(this.mapKeyword)
    },
    mapButton() {
      this.showmap = true;
    },
    closeMap() {
      console.log(2);
      this.showmap = false;
    },
    getpoint(e) {
      console.log(e.lng, e.lat);
      this.mapPoint = e;
    },
    closeIndustry(){
      this.showIndustry = false;
    },
    //行业返回上一级
    lastPage(){
      this.history.pop();
      console.log(this.history);
      if(this.history.length == 0){
        this.showlist = this.industryList;
        this.showLastPage = false;
      }else{
        var list = this.industryList;
        this.history.forEach(item=>{
            list = list[item].children;
        })
        this.showlist = list;
      }
    },
    //选择行业
    selectItem(index){
      console.log(index);
      console.log(this.showlist[index]);
      if(this.showlist[index].children.length){
        this.history.push(index);
        this.showlist = this.showlist[index].children;
        this.showLastPage = true;
      }else{
        this.industryName = this.showlist[index].name;
        this.formData.industry_id = this.showlist[index].id;
        this.buttonText = '重新选择';
        this.showIndustry = false;
        this.showlist = this.industryList;
      }
    },
    // 图片上传
    // 文件选取的时候调用
    changefile(file, fileList) {
      this.imageUrl = URL.createObjectURL(file.raw);
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      console.log(file, fileList);
      this.imgdata = {
        token: this.token,
        image: file.raw,
        type: "1",
        file_group: "1"
      };
    },
    //上传成功
    handleAvatarSuccess(res, file) {
      console.log(res);
      this.imageUrl = URL.createObjectURL(file.raw);
      this.image_id = res.data.id;
      this.save();
    },
    //保存表单
    save() {
      var data = Object.assign({}, this.formData);
      data.logo = this.image_id;
      data.token = this.token;
      data.app_id = this.app_id;
      data.lng = this.mapPoint.lng;
      data.lat = this.mapPoint.lat;
      console.log(data);
      this.$refs["formData"].validate(valid => {
        if (valid) {
          if (this.if_add) {
            AddMerchant(data).then(res => {
              console.log(res);
              if (res.code == "1") {
                this.$message({
                  type: "success",
                  message: res.msg
                });
                this.goback();
              } else {
                this.$message({
                  type: "error",
                  message: res.msg
                });
              }
            });
          } else {
            EditMerchant(data).then(res => {
              console.log(res);
              if (res.code == "1") {
                this.$message({
                  type: "success",
                  message: res.msg
                });
                this.goback();
              } else {
                this.$message({
                  type: "error",
                  message: res.msg
                });
              }
            });
          }
        } else {
          this.$message({
            type: "warning",
            message: "表单信息不完整"
          });
        }
      });
    }
  }
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-top: 10px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
</style>
<style lang="scss" scoped>
.content {
  padding: 10px 55px 30px 0;
  height: calc(100vh - 102px);
  .bodycontent {
    position: relative;
    padding: 27px;
    font-size: 14px;
    height: 96%;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    overflow: auto;
    .input_box {
      width: 600px;
    }
    .half_input {
      width: 180px;
      margin-right: 27px;
    }
    .state_text {
      color: #999;
      font-size: 12px;
      height: 20px;
      line-height: 30px;
    }
    .bottom_btn {
      margin-left: 180px;
      margin-top: 30px;
      .ml30 {
        margin-left: 30px;
      }
    }
    .map_search {
      margin-bottom: 10px;
    }
    .map_button {
      height: 40px;
      line-height: 40px;
      margin-top: 20px;
      span {
        margin-right: 20px;
      }
      div {
        float: right;
      }
    }
    .label {
      margin-top: 20px;
      p {
        height: 50px;
        width: 180px;
        line-height: 50px;
        text-align: right;
        padding-right: 0 12px;
        font-size: 15px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        span {
          margin-right: 6px;
          border-left: 3px solid #008aff;
          border-right: 3px solid #008aff;
          border-radius: 3px;
        }
      }
      .longtext {
        width: 240px;
      }
    }
    //行业选项
    .industry_list{
      max-height: 500px;
      overflow: auto;
      .industry_item{
        border-top: 1px solid #eee;
        height: 40px;
        line-height: 40px;
        display: flex;
        padding: 0 10px;
        .name{
          flex:1;
        }
        .arrow{
          width:7px;
          margin-left: 3px;
        }
      }
      .industry_empty{
        height: 90px;
        line-height: 90px;
        text-align: center;
        font-size: 14px;
        color: #8C8C8C;
      }
    }
    // 图片上传
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }
    .avatar {
      width: 100px;
      height: 100px;
      display: block;
    }
  }
}
</style>
